import clsx from 'clsx';
import { ExclamationTriangleIcon, LockClosedIcon } from '@heroicons/react/24/outline';

interface DpBoardMessageProps {
    title: string;
    description: string;
    tone: 'warning' | 'danger';
}

/**
 * Bloco que substitui o painel quando ele não pode ser mostrado.
 *
 * Falta de permissão e falha de carregamento pedem ações diferentes do usuário — reautenticar num
 * caso, tentar de novo no outro —, então não compartilham a mesma mensagem genérica.
 */
export function DpBoardMessage({ title, description, tone }: DpBoardMessageProps) {
    const Icon = tone === 'warning' ? LockClosedIcon : ExclamationTriangleIcon;

    return (
        <div
            role="alert"
            className={clsx(
                'rounded-2xl border p-8 text-center',
                tone === 'warning'
                    ? 'border-amber-200 bg-amber-50'
                    : 'border-red-200 bg-red-50'
            )}
        >
            <span
                className={clsx(
                    'mx-auto flex h-12 w-12 items-center justify-center rounded-full',
                    tone === 'warning' ? 'bg-amber-100' : 'bg-red-100'
                )}
                aria-hidden="true"
            >
                <Icon
                    className={clsx(
                        'h-6 w-6',
                        tone === 'warning' ? 'text-amber-700' : 'text-red-700'
                    )}
                />
            </span>

            <h2
                className={clsx(
                    'mt-3 text-base font-semibold font-montserrat',
                    tone === 'warning' ? 'text-amber-900' : 'text-red-900'
                )}
            >
                {title}
            </h2>
            <p
                className={clsx(
                    'mx-auto mt-2 max-w-xl text-sm font-montserrat',
                    tone === 'warning' ? 'text-amber-800' : 'text-red-800'
                )}
            >
                {description}
            </p>
        </div>
    );
}

export default DpBoardMessage;
